import { AddVersionState, initialState } from './add-version.state';
import { AddVersionActions, AddVersionActionType } from './add-version.actions';
import * as Objects from '@core/objects';

export function addVersionReducer(state = initialState, action: AddVersionActions): AddVersionState {
    switch (action.type) {
        case AddVersionActionType.Clear:
            return { ...state, data: null, savedVersion: null, creatingNewVersion: false, saved: false, errors: initialState.errors };

        case AddVersionActionType.SetErrors:
            return { ...state, errors: { ...state.errors, ...action.errors } };

        case AddVersionActionType.ClearErrors:
            return { ...state, errors: initialState.errors };

        case AddVersionActionType.SubmitAddVersion:
            return { ...state, creatingNewVersion: true, saved: false, errors: initialState.errors };

        case AddVersionActionType.SubmitAddVersionSuccess:
            return {
                ...state,
                savedVersion: action.version,
                creatingNewVersion: false,
                saved: true,
                errors: initialState.errors
            };

        case AddVersionActionType.SubmitAddVersionFailure:
            return { ...state, creatingNewVersion: false, saved: false };

        default:
            return state;
    }
}